import { render } from "./CreateConfirmReceiptOwner.vue?vue&type=template&id=fe128ec0&scoped=true"
import script from "./CreateConfirmReceiptOwner.vue?vue&type=script&lang=js"
export * from "./CreateConfirmReceiptOwner.vue?vue&type=script&lang=js"

import "./CreateConfirmReceiptOwner.vue?vue&type=style&index=0&id=fe128ec0&scoped=true&lang=css"
import "./CreateConfirmReceiptOwner.vue?vue&type=style&index=1&id=fe128ec0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe128ec0"]])

export default __exports__